import Hero from "@/components/sections/Hero";
import Positioning from "@/components/sections/Positioning";
import MakhanaHome from "@/components/sections/MakhanaHome";
import About from "@/components/sections/About";
import Solutions from "@/components/sections/Solutions";
import Species from "@/components/sections/Species";
import Process from "@/components/sections/Process";
import Shrimp from "@/components/sections/Shrimp";
import { Sustainability, WhyPartners } from "@/components/sections/SustainWhy";
import Contact from "@/components/sections/Contact";
import useSeo from "@/lib/useSeo";

export default function Home() {
  useSeo({
    title: "AquaFionix | Indian Makhana Exporter & Aquaculture — Food Products & Export",
    description: "AquaFionix connects quality Indian products with global markets — export-oriented Makhana (Fox Nuts) supply as our priority, with RAS-assisted, high-tech shrimp and crab farming planned around a zero-waste approach.",
  });
  return (
    <>
      <Hero />
      <Positioning />
      <MakhanaHome />
      <About />
      <div id="aquaculture" className="scroll-mt-20">
        <Solutions />
        <Species />
        <Process />
        <Shrimp />
        <Sustainability />
      </div>
      <WhyPartners />
      <Contact />
    </>
  );
}
